import AddMacid from './AddMacid';

export default AddMacid;
